<template>
  <div class="base-text-input-container base-input">
    <label class="input-label">{{ getLabel }}</label>
    <input
    v-if="getType === 'number'"
      class="base-text-input"
      :type="getType"
      :id="getFieldValue"
      :placeholder="Item.placeholder"
      v-model="InputValue"
      @input="handleInputValue"
      :required="Item.required"
      step="any"
    />
        <input
        v-else
      class="base-text-input"
      :type="getType"
      :id="getFieldValue"
      :placeholder="Item.placeholder"
      v-model="InputValue"
      @input="handleInputValue"
      :required="Item.required"
    />
  </div>
</template>

<script>
export default {
  data () {
    return {
      textValue: null
    };
  },
  props: [
    'dataInput',
    'type',
  ],
  computed: {
    Item () {
      return this.$props.dataInput;
    },
    getType () {
      return this.Item.type;
    },
    getLabel () {
      return this.Item.label;
    },
    InputValue: {
      get () {
        return this.Item.value;
      },
      set (value) {
        this.Item.value = value;
        this.handleInputValue();
      }
    },
    getFieldValue () {
      return this.Item.value;
    }
  },
  methods: {
    handleInputValue () {
      this.$emit('input-value', this.Item);
    }
  }
};
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.base-text-input-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.base-text-input {
  font-size: 16px;
  padding: .5em;
  height: 100%;
  display: block;
  width: 100%;
  background: #F7F6F1;
  border: 1px solid #D3CDC2;
}
.input-label {
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 2px;
}
</style>